import { createTextSprite } from './createTextSprite';

function updateExistingSpriteText(sprite, newText) {
  if (!sprite || !newText) return;
  const { drawText, texture, canvas } = sprite.userData || {};
  if (typeof drawText === 'function' && texture && canvas) {
    drawText(newText);
    texture.needsUpdate = true;
    try {
      sprite.scale.set(canvas.width / 10, canvas.height / 10, 1);
      sprite.userData.text = newText;
    } catch (e) {}
  }
}

/**
 * Panel'lerin title'larını simpleSupply verilerine göre günceller
 * @param {THREE.Scene} scene - Three.js scene
 * @param {object} simpleSupply - Simple supply state
 */
export function updatePanelTitles(scene, simpleSupply) {
  if (!scene || !simpleSupply?.components) return;

  scene.traverse((object) => {
    // Panel objesini bul
    if (object.name === 'panel' && object.userData?.id) {
      const componentId = object.userData.id;

      // SimpleSupply'dan component verilerini al
      const component = simpleSupply.components.find(c => c.id === componentId);
      if (!component) return;

      const installedPower = component.electrical?.installedPower || 0;
      const panelName = component.name || "Panel";

      // Mevcut title'ları temizle
      const offsetGroup = object.children.find(child => child.name === 'offsetGroup');
      if (offsetGroup) {
        // If a titleGroup (the larger title created by createPanel/createMainPanel)
        // already exists, update its linked sprites instead of creating small
        // duplicate title sprites.
        const titleGroup = offsetGroup.getObjectByName('titleGroup') || offsetGroup.children.find(c => c.userData?.isTitle);
        const powerText = `${installedPower}W`;
        const nameText = panelName;

        if (titleGroup && Array.isArray(titleGroup.userData?.linkedSprites) && titleGroup.userData.linkedSprites.length >= 1) {
          // Update only the name sprite for now (power display temporarily disabled)
          const linked = titleGroup.userData.linkedSprites;
          const nameLinked = linked.find(s => s && s.userData && s.userData.role === 'name') || linked[0];
          try { updateExistingSpriteText(nameLinked, nameText); } catch (e) {}
          return;
        }

        // Fallback: remove any existing small panelTitle1/panelTitle2 and recreate
        const existingTitles = offsetGroup.children.filter(child =>
          child.name === 'panelTitle1' || child.name === 'panelTitle2'
        );

        existingTitles.forEach(title => {
          offsetGroup.remove(title);
          if (title.material && title.material.map) {
            title.material.map.dispose();
          }
          if (title.material) {
            title.material.dispose();
          }
        });

        // Yeni title'lar oluştur - only create the panel name for now
        const line1 = nameText;
        const titleSprite1 = createTextSprite(line1, {
          fontSize: 20,
          color: '#ffffff',
          backgroundColor: 'transparent',
          strokeColor: 'black',
          padding: 4
        });
        titleSprite1.position.set(0, 12.5 + 12, 0.1); // panelHeight/2 + 12
        titleSprite1.name = "panelTitle1";
        offsetGroup.add(titleSprite1);
      }
    }
  });
}

/**
 * Belirli bir panel'in title'ını günceller
 * @param {THREE.Scene} scene - Three.js scene
 * @param {string} componentId - Component ID
 * @param {object} component - Component data
 */
export function updateSinglePanelTitle(scene, componentId, component) {
  if (!scene || !componentId || !component) return;

  scene.traverse((object) => {
    if (object.name === 'panel' && object.userData?.id === componentId) {
      const installedPower = component.electrical?.installedPower || 0;
      const panelName = component.name || "Panel";

      // Title güncelleme logic'i - supply point style ile
      const offsetGroup = object.children.find(child => child.name === 'offsetGroup');
      if (offsetGroup) {
        // Mevcut title'ları temizle
        const existingTitles = offsetGroup.children.filter(child =>
          child.name === 'panelTitle1' || child.name === 'panelTitle2'
        );

        existingTitles.forEach(title => {
          offsetGroup.remove(title);
          if (title.material && title.material.map) {
            title.material.map.dispose();
          }
          if (title.material) {
            title.material.dispose();
          }
        });

        // Yeni title'lar oluştur - supply point style ile
        const line1 = panelName;
        const line2 = `${installedPower}W`;

        const titleSprite1 = createTextSprite(line1, {
          fontSize: 20,
          color: '#ffffff',
          backgroundColor: 'transparent',
          strokeColor: 'black',
          padding: 4
        });
        titleSprite1.position.set(0, 12.5 + 12, 0.1);
        titleSprite1.name = "panelTitle1";
        offsetGroup.add(titleSprite1);

        const titleSprite2 = createTextSprite(line2, {
          fontSize: 16,
          color: '#ffffff',
          backgroundColor: 'transparent',
          strokeColor: 'black',
          padding: 4
        });
        titleSprite2.position.set(0, 12.5 + 25, 0.1);
        titleSprite2.name = "panelTitle2";
        offsetGroup.add(titleSprite2);
      }
    }
  });
}